<template>
  <section v-if="articles.length" :class="$style.container">
    <Wrapper :class="$style.inner">
      <h2 :class="$style.title">{{ title }}</h2>
      <div :class="$style.categoryList">
        <ArticleThumbnail
          v-for="(article, articleI) in articles"
          :key="article.uid + articleI"
          :article="article"
          :class="[
            [$style.article],
            { [$style.highlighted]: article.data.highlight_article },
          ]"
          :is-horizontal="!article.data.highlight_article"
          :is-big="article.data.highlight_article"
        />
      </div>
    </Wrapper>
  </section>
</template>

<script>
import ArticleThumbnail from '~/components/ArticleThumbnail'

export default {
  name: 'ArticlesList',

  components: {
    ArticleThumbnail,
  },

  props: {
    articles: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    title() {
      const categoryId = this.articles[0].data.category_page.id
      const categoryName =
        this.$store.state.adviceCategoryData[categoryId].category_name
      if (this.$i18n.locale === 'fr') {
        return `Articles dans ${categoryName}`
      }
      return `Articles in ${categoryName}`
    },
  },
}
</script>

<style lang="scss" module>
.container {
  margin: 80px 0;
  padding: 0 24px;
}

.title {
  @include typo-extra-title;
  font-weight: 200;
}

.categoryList {
  display: grid;
  gap: 40px;
  margin-top: 24px;

  @include above(small) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.article {
  @include below(large) {
    & > div {
      flex-direction: column !important;
      align-items: flex-start !important;
      img {
        max-width: none !important;
      }
    }
  }
  &.highlighted {
    grid-row: span 2;
    a > img {
      height: 100%;
    }

    @include below(small) {
      a > img {
        height: 192px !important;
        min-height: unset !important;
      }
      h3 {
        font-size: 20px !important;
        line-height: 32px !important;
      }
    }

    @include above(medium) {
      grid-row: span 3;
    }
  }
}
</style>
